import { render, staticRenderFns } from "./Barcodescan.vue?vue&type=template&id=2097dbaa&"
import script from "./Barcodescan.vue?vue&type=script&lang=js&"
export * from "./Barcodescan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports